const packages = [
  {
    name: "diabetic health checkup",
    about: "Get the comprehensive Diabetic Health Checkup plan and maintain your overall health with ewarly detection of complications.",
    actualPrice: "1999",
    investigations: [
      "CBP",
      "CUE",
      "HbA1C",
      "Serum Creatinine",
      "FBS, PLBS",
      "Blood Urea",
      "HDL",
      "Sodium",
      "LDL",
      "Potassium",
      "VLDL",
      "Chloride",
      "Total Cholesterol",
      "Diabetic Foot Checkup",
      "Triyglycerides",
      "Physician Consultation",
    ],
  },
  {
    name: "general health checkup",
    about: "A step towards lifelong of health with full body checkup to detect and prevent the potential issues in advance.",

    actualPrice: "2699",
    investigations: [
      "CBP",
      "Ultrasound - Abdomen & Pelvis",
      "CUE",
      "X-Ray Chest PA View",
      "RBS",
      "Blood Grouping with Rh Typing",
      "ECG",
      "Alkaline Phosphatase",
      "SGPT",
      "Bilirubin (Direct & Indirect)",
      "SGOT",
      "Physician Consultation",
      "Serum Creatinine"

    ],
  },
  {
    name: "cardiac profile",

    about: "Ensuring a healthy heart with thorough evaluation and screening with our complete Cardiac Profile for risk elimination.",

    actualPrice: "6499",
    investigations: [
      "ECG",
      "CBP",
      "Total Cholesterol",
      "RBS",
      "Triyglycerides",
      "TMT",
      "HDL",
      "2D ECHO",
      "LDL",
      "X-Ray Chest PA View",
    ],
  },
  {
    name: "executive health checkup (female)",
    about: "Promoting healthy life and wellness to all the women with our extensive health checkup plan curated especially for females.",

    actualPrice: "6999",
    investigations: [
      "CBP",
      "Total Cholesterol",
      "CUE",
      "Triyglycerides",
      "ESR",
      "Vitamin D Total",
      "FBS",
      "Blood Grouping with Rh Typing",
      "PLBS",
      "Bilirubin (Direct & Indirect)",
      "HbA1C",
      "Alkaline Phosphatase",
      "HDL",
      "Serum Albumin",
      "LDL",
      "Serum Globulin",
      "VLDL",
      "Uric Acid, A:G Ratio",
      "SGOT",
      "Serum Creatinine",
      "SGPT",
      "Blood Urea",
      "T3,T4 & TSH",
      "Serum Uric Acid",
      "HBsAg",
      "PAP Smear",
      "2D Echo",
      "Ultrasound - Abdomen & Pelvis",
      "ECG",
      "X-Ray Chest PA View",
      "PFT",
      "Physician Consultation",
    ],
  },
  {
    name: "executive health checkup (male)",
    about: "Get the advanced health screening for effectively managing the health at all stages with preventive tips and personalised solutions for men.",

    actualPrice: "6999",
    investigations: [
      "CBP",
      "Total Cholesterol",
      "CUE",
      "Triyglycerides",
      "ESR",
      "Vitamin D Total",
      "FBS",
      "Blood Grouping with Rh Typing",
      "PLBS",
      "Bilirubin (Direct & Indirect)",
      "HbA1C",
      "Alkaline Phosphatase",
      "HDL",
      "Serum Albumin",
      "LDL",
      "Serum Globulin",
      "VLDL",
      "Total Proteins, A:G Ratio",
      "SGOT",
      "Serum Creatinine",
      "SGPT",
      "Blood Urea",
      "T3,T4 & TSH",
      "Serum Uric Acid",
      "HBsAg",
      "PSA",
      "2D Echo",
      "Ultrasound - Abdomen & Pelvis",
      "ECG",
      "X-Ray Chest PA View",
      "PFT",
      "Physician Consultation",
    ],
  },
  {
    name: "master health checkup",
    about: "Detailed health  checkup with diagnostic tests to get complete image of the underlying issues from minor to complex issues.",

    actualPrice: "4599",
    investigations: [
      "CBP",
      "Total Proteins, A:G Ratio",
      "ESR",
      "Serum Albumin",
      "FBS",
      "Serum Globulin",
      "PLBS",
      "Serum Creatinine",
      "HbA1C",
      "Blood Urea, CUE",
      "ECG",
      "Total Cholesterol",
      "TSH",
      "Triyglycerides",
      "HBsAg",
      "Bilirubin (Direct & Indirect)",
      "HDL",
      "Alkaline Phosphatase",
      "LDL",
      "Blood Grouping with Rh Typing",
      "VLDL",
      "Ultrasound - Abdomen & Pelvis",
      "SGOT",
      "X-Ray Chest PA View",
      "SGPT",
      "Physician Consultation",
    ],
  },
  {
    name: "wholebody health checkup",
    about: "Whole Body Checkup is specially planned to detect, diagnose and monitor the entire body ensuring to cover major parameters.",

    actualPrice: "8999",
    investigations: [
      "CBP",
      "ESR",
      "FBS",
      "PLBS",
      "HbA1C",
      "HBsAg",
      "HDL",
      "LDL",
      "VLDL",
      "SGOT",
      "SGPT",
      "T3&T4",
      "TSH",
      "PFT",
      "ECG",
      "TMT",
      "2D Echo",
      "CUE",
      "Total Cholesterol",
      "Triyglycerides",
      "Bilirubin (Direct & Indirect)",
      "Alkaline Phosphatase",
      "Total Proteins",
      "Serum Albumin",
      "Serum Globulin",
      "A:G Ratio",
      "Serum Calcium",
      "Serum Creatinine",
      "Blood Urea",
      "Serum Uric Acid",
      "PSA (Male)",
      "PAP Smear (Female)",
      "Vitamin D Total",
      "Ultrasound - Abdomen & Pelvis",
      "X-Ray Chest PA View",
      "Physician Consultation",
    ],
  },
  {
    name: "renal (kidney) health checkup",
    about: "Detect the signs of risk and get the preventive tips for maintaining the health and proper functioning of kidneys with Renal health checkup.",

    actualPrice: "2999",
    investigations: [
      "Urea",
      "Creatinine",
      "Sodium",
      "Potassium",
      "Chloride",
      "CUE",
      "CBP",
      "RBS",
      "Ultrasound - Abdomen & Pelvis",
      "X-Ray Chest PA View"
    ],
  },
  {
    name: "d2 infertility profile",
    about: "Examine your reproductive problems interfering in your fertility and get the personalised solutions with D2 Infertility Profile.",

    actualPrice: "5999",
    investigations: [
      "CBP",
      "T3, T4 & TSH",
      "LH",
      "Prolactin",
      "FSH",
      "Estradiol (E2)", "AMH"
    ],
  },
  {
    name: "medical termination of pregnancy (MTP)",
    about: "Get the safest MTP with the expert support and care where we ensure the confidentiality for your well-being.",

    actualPrice: "5999",
    investigations: [
      "CBP",
      "Blood Grouping with Rh Typing",
      "Fetal Viability Scan",
      "T3,T4 & TSH",
      "MTP Unwanted Kit",
    ],
  },
  {
    name: "lung health checkup",
    about: "With complete package  to protect and maintain your lungs with Lung Health Checkup for your respiratory wellness.",

    actualPrice: "4799",
    investigations: [
      "CBP",
      "ECG",
      "D-Dimer",
      "2D Echo",
      "CRP",
      "X-Ray Chest PA View",
      "PFT",
      "Pulmonologist Consultation",
    ],
  },
  {
    name: "allergy checkup",
    about: "Improve your quality of life with the diagnosis of symptoms that trigger your normal lifestyle with Allergy Checkup plans.",

    actualPrice: "1499",
    investigations: [
      "CBP",
      "AEC",
      "Total IgE Levels",
      "Allergologist Consultation",

    ],
  },
  {
    name: "anc profile",
    about: "Trust the ANC checkups to ensure the health and safety of pregnant women with personalised care.",

    actualPrice: "4299",
    investigations: [
      "CBP",
      "VDRL",
      "RBS",
      "T3, T4 & TSH",
      "CUE",
      "Serum Creatinine",
      "HIV",
      "Blood Grouping with Rh Typing",
      "HCV",
      "Bilirubin (Direct & Indirect)",
      "HBsAg",
      "Alkaline Phosphatase",
      "SGOT",
      "Total Proteins",
      "SGPT",
      "Serum Albumin",
      "A:G Ratio",
      "Serum Globulin",
    ],
  },
  {
    name: "nutrient panel",
    about: "Identify the nutritional deficiencies at an early stage and get the complete Nutrient Panel package for a balanced life.",

    actualPrice: "2999",
    investigations: [
      "Iron",
      "Magnesium",
      "Vitamin B12",
      "TIBC",
      "Calcium",
      "Phosphorus",
      "Serum Ferritin",
      "Vitamin D",
    ],
  },
];

export default packages;
